import dataService from "../../api";
import { status } from "@/utils/common";
import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";

const state = {
    appointments: [],
    appointment: {
        id: null,
        fullName: null,
        bloodType: null,
        birthDate: null,
        gender: null,
        disease: [],
        skinIssues: [],
    },
    doctors: [],
    totalItems: 0,
};
const getters = {
    index: state => (id) => state.appointments.findIndex(i => i.id === id)
};
const mutations = {
    SET_APPOINTMENTS: (state, data) => state.appointments = data,
    SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
    SET_APPOINTMENT: (state, viewData) => state.appointment = viewData,
    SET_DOCTORS: (state, viewData) => state.doctors = viewData,
    ADD: (state, addedData) => state.appointments.unshift(addedData),
    UPDATE: (state, { index, updateData }) => state.appointments.splice(index, 1, updateData),
    // DELETE: (state, index) => state.appointments.splice(index, 1),
    approval: (state, index) => state.appointments[index].status = status.active,
    DELETE: (state, index) => state.appointments[index].status = status.rejected,

};
const actions = {
  
    // ADD Patient by staps 
    async addPatient(_, payload) {
        startLoading()
        try {
            const response = await dataService.bookPatients.addPatient(payload);

            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            return  Promise.resolve(response.data);
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async addAppointment(_, payload) {
        startLoading()
        try {
           const response = await dataService.bookPatients.addAppointment(payload);
            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            // showNotification(response.data.message);
          return  Promise.resolve(response.data);
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async addPayment(_, {id ,payload}) {
        startLoading()
        try {
            const response = await dataService.bookPatients.addPayment(id,payload);

            stopLoading()
            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showNotification(response.data.message);
          return  Promise.resolve(response.data);
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
